// ================================
// User Permissions check
// ================================

import { get } from 'svelte/store'

import { browser } from '$app/environment'
import type { User } from '$lib/stores/user/types'

import { InitUser, user_store } from './user'


// TODO: get modules list from the server modules_store (table modules)
const modules = [
	'users',
	'invoices',
	'estimates',
	'expenses',
	'clients',
	'items',
	'taxes',
	'settings',
	'ai_assistant',
]


export async function UserUrlEnabled(url?: URL) {

	let module = ''

	if (!url) return true
	
	if (url) {
		const pathParts = url.pathname.split('/')
		module = pathParts[1] 
	}
	if (!module) return true

	await InitUser()
	const user = get(user_store)
	const enabled = await UserModuleEnabledSync(module, user)
	return enabled
}

export function UserModuleEnabledSync(module='', user: User ) {
	if (!browser) return false
	if (module === '') return true
	if (module && !modules.includes(module)) return true

	if (user.firebase_id === user.account_id) return true


	// special case derived from other modules
	if (module === 'clients' || module === 'items' || module === 'taxes') {
		const view_permission = '$.invoices.view'
		let enabled = !!user.permission_keys.find(p => p === view_permission)
		if (!enabled) {
			const view_permission = '$.estimates.view'
			enabled = !!user.permission_keys.find(p => p === view_permission)
		}
		return enabled
	}
	
	if (module && modules.includes(module)) {
		const view_permission = `$.${module}.view`
		return !!user.permission_keys.find(p => p === view_permission)
	}

	return true
}

export async function UserActionEnabled(requiredPermission?: string) {
	if (!browser) return false
	await InitUser()
	const user = get(user_store)
	return UserActionEnabledSync(requiredPermission, user)
}

export function UserActionEnabledSync(requiredPermission?: string, user?: User) {
	if (!browser) return false
	if (!requiredPermission) return true
	if (!user) return false
	if (user.firebase_id === user.account_id) return true

	// Handle special cases for derived permissions
	// special cases derived from other modules
	const derivedModules = ['clients', 'items', 'taxes']
	const permissionParts = requiredPermission.split('.')
	const [prefix, module, action, subAction] = permissionParts
	if (derivedModules.includes(module)) {
		const checkPermission = (baseModule: string) => {
			const derivedPermission = `$.${baseModule}.${action}.${subAction}`
			return user.permission_keys.includes(derivedPermission)
		}

		return checkPermission('invoices') || checkPermission('estimates')
	}

	// Direct permission check
	return user.permission_keys.includes(requiredPermission)
}